export default __webpack_public_path__ + "static/media/2536.cca63983.png";